import { http } from 'helpers/http';

const URL = process.env.REACT_APP_API;
const listLvl1 = 'process/company-value-chain';

export const apiListLvl1 = async (val) => {
  const datas = await http.post(`${URL + listLvl1}`, val);

  return datas.data.data;
};
